module.exports = __webpack_public_path__ + "static/media/Frame 124.7d9e5a7b.png";